/* src/app/private/components/leads/whatsapp-communication/whatsapp-communication.component.scss */
.dialog-content {
  padding: 1.5rem;
  max-height: 70vh;
  overflow-y: auto;
}
.whatsapp-button {
  background:
    linear-gradient(
      135deg,
      #25D366 0%,
      #128C7E 100%) !important;
  border: none !important;
}
.whatsapp-button:hover {
  background:
    linear-gradient(
      135deg,
      #128C7E 0%,
      #25D366 100%) !important;
}
.whatsapp-button .p-button-label {
  color: white !important;
}
.whatsapp-button .p-button-icon {
  color: white !important;
}
.p-inputtext {
  border: 1px solid var(--surface-border);
  border-radius: 6px;
  padding: 0.75rem;
  transition: all 0.3s ease;
  background-color: var(--surface-card);
  color: var(--text-color);
}
.p-inputtext:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}
.p-inputtext::placeholder {
  color: var(--text-color-secondary);
}
textarea {
  font-family: inherit;
  line-height: 1.5;
  background-color: var(--surface-card);
  color: var(--text-color);
  border: 1px solid var(--surface-border);
}
textarea:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}
textarea::placeholder {
  color: var(--text-color-secondary);
}
.p-button[outlined] {
  border: 1px solid var(--surface-border);
  color: var(--text-color-secondary);
}
.p-button[outlined]:hover {
  background-color: var(--surface-hover);
  border-color: var(--surface-border);
}
button {
  transition: all 0.2s ease;
  color: var(--text-color);
}
button:hover {
  transform: translateY(-1px);
}
label {
  color: var(--text-color-secondary);
  font-weight: 500;
}
@media (max-width: 768px) {
  .dialog-content {
    padding: 1rem;
  }
  .grid-cols-1.md\\:grid-cols-2 {
    grid-template-columns: 1fr;
  }
}
textarea::-webkit-scrollbar {
  width: 6px;
}
textarea::-webkit-scrollbar-track {
  background: var(--surface-ground);
  border-radius: 3px;
}
textarea::-webkit-scrollbar-thumb {
  background: var(--surface-border);
  border-radius: 3px;
}
textarea::-webkit-scrollbar-thumb:hover {
  background: var(--text-color-secondary);
}
.pi-whatsapp {
  color: #25D366 !important;
}
.pi-phone {
  color: #25D366 !important;
}
.text-xs {
  font-style: italic;
  color: var(--text-color-secondary);
}
.p-button[data-pc-name=button][aria-label*=loading] {
  opacity: 0.7;
}
.lead-details-section {
  background-color: var(--surface-card);
  border: 1px solid var(--surface-border);
  color: var(--text-color);
}
.info-section {
  background-color: var(--surface-hover);
  border: 1px solid var(--surface-border);
  color: var(--text-color);
}
.p-inputtext:focus,
textarea:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px rgba(var(--primary-color-rgb, 102, 126, 234), 0.1);
}
.p-button {
  transition: all 0.2s ease;
}
.p-button:focus {
  box-shadow: 0 0 0 2px rgba(var(--primary-color-rgb, 102, 126, 234), 0.3);
}
/*# sourceMappingURL=whatsapp-communication.component.css.map */
